import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Plus, Pencil, Trash2, Newspaper } from "lucide-react";
import { toast } from "sonner";
import { api, apiError, formatDate } from "@/lib/api";

export default function BlogAdmin() {
  const [posts, setPosts] = useState(null);
  const navigate = useNavigate();

  const load = () => api.get("/admin/blog").then((r) => setPosts(r.data)).catch((e) => toast.error(apiError(e)));
  useEffect(() => { load(); }, []);

  const remove = async (id) => {
    if (!window.confirm("Supprimer définitivement cet article ?")) return;
    await api.delete(`/admin/blog/${id}`);
    toast.success("Article supprimé");
    load();
  };

  return (
    <div data-testid="admin-blog">
      <div className="flex items-center justify-between mb-8 gap-4 flex-wrap">
        <h1 className="font-display text-2xl sm:text-3xl font-extrabold tracking-tight uppercase text-onyx">Blog / Actualités</h1>
        <button onClick={() => navigate("/admin/blog/nouveau")} data-testid="blog-add"
          className="inline-flex items-center gap-2 bg-rouge text-white px-5 py-2.5 text-sm font-bold uppercase tracking-wide hover:bg-rouge-hover transition-colors">
          <Plus className="w-4 h-4" /> Nouvel article
        </button>
      </div>

      {!posts ? <p className="text-muted-foreground">Chargement…</p> : posts.length === 0 ? (
        <div className="bg-white border border-line p-10 text-center" data-testid="blog-empty">
          <Newspaper className="w-8 h-8 text-rouge mx-auto mb-3" />
          <p className="text-sm text-muted-foreground">Aucun article. Créez le premier !</p>
        </div>
      ) : (
        <div className="space-y-3" data-testid="blog-list">
          {posts.map((p) => (
            <div key={p.id} className="bg-white border border-line p-5 flex items-center gap-4 flex-wrap" data-testid={`blog-row-${p.id}`}>
              <div className="flex-1 min-w-[220px]">
                <p className="font-display font-bold text-onyx">{p.title}</p>
                <p className="text-xs text-muted-foreground mt-0.5">
                  /actualites/{p.slug} · {formatDate(p.published_at || p.created_at)}
                </p>
              </div>
              <span className={`text-xs font-bold uppercase tracking-wide px-2.5 py-1 ${p.published ? "bg-field/10 text-field" : "bg-sand text-muted-foreground"}`}
                data-testid={`blog-status-${p.id}`}>
                {p.published ? "Publié" : "Brouillon"}
              </span>
              {p.published && (
                <Link to={`/actualites/${p.slug}`} target="_blank" className="text-xs font-bold uppercase text-med hover:underline">Voir</Link>
              )}
              <button onClick={() => navigate(`/admin/blog/${p.id}`)} data-testid={`blog-edit-${p.id}`} className="p-2 text-onyx hover:text-rouge" aria-label="Modifier"><Pencil className="w-4 h-4" /></button>
              <button onClick={() => remove(p.id)} data-testid={`blog-delete-${p.id}`} className="p-2 text-onyx hover:text-destructive" aria-label="Supprimer"><Trash2 className="w-4 h-4" /></button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
